import React from 'react';
import styles from './Button.module.scss';

const Button = ({
    title,
    disabled,
    secondary,
    danger,
    info,
    large,
    width,
    marginRight,
    autoMargin,
    spacing: letterSpacing,
    className,
    ...props
}) => {
    const getClassNames = () =>
        `${styles.button} 
        ${large ? styles.large : ''} 
        ${className} 
        ${secondary ? styles.secondary : ''}
        ${danger ? styles.danger : ''}
        ${info ? styles.info : ''}
        ${autoMargin ? styles.autoMargin : ''}
        `;

    return (
        <button
            className={getClassNames()}
            style={{ width, letterSpacing, marginRight }}
            disabled={disabled}
            {...props}
        >
            {title}
        </button>
    );
};

export default Button;
